/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Consistent_For_6mto1yInputs */

const en_us2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 months to 1 year`)
};

const pt_br2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 1 ano`)
};

const es_419_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 1 año`)
};

const pt_pt2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 6 meses a 1 ano`)
};

const fr_fr2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 mois à 1 an`)
};

const de_de2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Monate bis 1 Jahr`)
};

const it_it2_onboarding_experience_consistent_for_6mto1y = /** @type {(inputs: Onboarding_Experience_Consistent_For_6mto1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 6 mesi a 1 anno`)
};

/**
* | output |
* | --- |
* | "6 months to 1 year" |
*
* @param {Onboarding_Experience_Consistent_For_6mto1yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_consistent_for_6mto1y = /** @type {((inputs?: Onboarding_Experience_Consistent_For_6mto1yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Consistent_For_6mto1yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_consistent_for_6mto1y(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_consistent_for_6mto1y(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_consistent_for_6mto1y(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_consistent_for_6mto1y(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_consistent_for_6mto1y(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_consistent_for_6mto1y(inputs)
	return en_us2_onboarding_experience_consistent_for_6mto1y(inputs)
});
export { onboarding_experience_consistent_for_6mto1y as "onboarding.experience_consistent_for.6mto1y" }